<div odxLayout="flex gap-small" class="flex-column h-100">
  <odx-area-header class="info-header">
    <h5 class="odx-title-5" i18n="@@checklistMonitoring.header">Checkliste Monitoring</h5>
  </odx-area-header>
  <form odxForm [formGroup]="checklistForm" class="form">
    <h6 class="odx-title-6 odx-padding-bottom-16" i18n="@@checklist.header.general">Allgemein</h6>

    <app-checklist-item
      label="Existing Install Base?"
      i18n-label="@@checklistMonitoring.existingInstallBase.label"
      groupName="existingInstallBase"
      notesPlaceholder="Provide current devices and software levels"
      [disabled]="!isChecked('existingInstallBase.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item-single-choice
      label="Networked?"
      i18n-label="@@checklistMonitoring.networked.label"
      subLabel="Check type of network"
      i18n-subLabel="@@checklistMonitoring.networked.subLabel"
      groupName="networked"
      [options]="this.checklistOptions['networked']"
      [disabled]="isControlDisabled('networked.choice')"
    ></app-checklist-item-single-choice>
    <hr />

    <app-checklist-item
      label="Are we supplying network cables?"
      i18n-label="@@checklistMonitoring.networkCableSupply.label"
      groupName="networkCableSupply"
      notesPlaceholder="Detail which colour and length"
      i18n-notesPlaceholder="@@checklistMonitoring.networkCableSupply.notesPlaceholder"
      [disabled]="!isChecked('networkCableSupply.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Wireless Network Required?"
      i18n-label="@@checklistMonitoring.wirelessNetworkRequired.label"
      groupName="wirelessNetworkRequired"
      notesPlaceholder="M540/M300 VLAN required"
      i18n-notesPlaceholder="@@checklistMonitoring.wirelessNetworkRequired.notesPlaceholder"
      [disabled]="!isChecked('wirelessNetworkRequired.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Is device interfacing required"
      i18n-label="@@checklistMonitoring.deviceInterfacingRequired.label"
      groupName="deviceInterfacingRequired"
      notesPlaceholder="Which manufacturers devices and software levels"
      i18n-notesPlaceholder="@@checklistMonitoring.deviceInterfacingRequired.notesPlaceholder"
      [disabled]="!isChecked('deviceInterfacingRequired.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item-multiple-choice
      label="Includes Central Station?"
      i18n-label="@@checklistMonitoring.centralStrationIncluded.label"
      subLabel="How is it to be mounted and is UPS required?"
      i18n-subLabel="@@checklistMonitoring.centralStrationIncluded.subLabel"
      groupName="centralStationIncluded"
      [options]="this.checklistOptions['centralStationIncluded']"
      [disabled]="isControlDisabled('centralStationIncluded.choices')"
    >
    </app-checklist-item-multiple-choice>
    <hr />

    <app-checklist-item-secondary-displays
      label="Secondary Displays included?"
      i18n-label="@@checklistMonitoring.secondaryDisplaysIncluded.label"
      subLabel="Secondary Display Requirements"
      i18n-subLabel="@@checklistMonitoring.secondaryDisplaysIncluded.subLabel"
      groupName="secondaryDisplaysIncluded"
      notesPlaceholder="Additional details"
      i18n-notesPlaceholder="@@checklistMonitoring.secondaryDisplaysIncluded.notesPlaceholder"
      [checklistOptions]="this.checklistOptions"
      [checklistForm]="this.checklistForm"
      [disabled]="isControlDisabled('secondaryDisplaysIncluded.choices')"
    >
    </app-checklist-item-secondary-displays>
    <hr />

    <app-checklist-item
      label="Is hospital using their own printer?"
      i18n-label="@@checklistMonitoring.ownPrinter.label"
      groupName="ownPrinter"
      notesPlaceholder="Printer type and model"
      i18n-notesPlaceholder="@@checklistMonitoring.ownPrinter.notesPlaceholder"
      [disabled]="!isChecked('ownPrinter.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item-multiple-choice
      label="Includes IT apps?"
      i18n-label="@@checklistMonitoring.itAppsIncluded.label"
      subLabel="Select which apps will be installed"
      i18n-subLabel="@@checklistMonitoring.itAppsIncluded.subLabel"
      groupName="itAppsIncluded"
      [options]="this.checklistOptions['itAppsIncluded']"
      [disabled]="isControlDisabled('itAppsIncluded.choices')"
    >
    </app-checklist-item-multiple-choice>
    <hr />

    <app-checklist-item
      label="Includes Digital solutions"
      i18n-label="@@checklistMonitoring.digitalSolutionsIncluded.label"
      groupName="digitalSolutionsIncluded"
      notesPlaceholder="List which solutions"
      i18n-notesPlaceholder="@@checklistMonitoring.digitalSolutionsIncluded.notesPlaceholder"
      [disabled]="!isChecked('digitalSolutionsIncluded.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item-single-choice
      label="Server Location?"
      i18n-label="@@checklistMonitoring.serverLocation.label"
      groupName="serverLocation"
      [options]="this.checklistOptions['serverLocation']"
      [disabled]="isControlDisabled('serverLocation.choice')"
    >
    </app-checklist-item-single-choice>
    <hr />

    <app-checklist-item
      label="Additional Information"
      i18n-label="@@checklistMonitoring.additionalInformation.label"
      groupName="additionalInformation"
      [disabled]="!isChecked('additionalInformation.checked')"
    >
    </app-checklist-item>

    <hr />
    <h6 class="odx-title-6 headline-padding" i18n="@@checklist.header.installationInstructions">Installationsanweisungen</h6>

    <app-checklist-item-single-choice
      label="Who will be installing wall or ceiling mounts?"
      i18n-label="@@checklistMonitoring.mountInstaller.label"
      groupName="mountInstaller"
      [options]="this.checklistOptions['mountInstaller']"
      [disabled]="isControlDisabled('mountInstaller.choice')"
    >
    </app-checklist-item-single-choice>
    <hr />

    <app-checklist-item
      label="Do wall channels need to be supplied early?"
      i18n-label="@@checklistMonitoring.earlyChannelSupply.label"
      groupName="earlyChannelSupply"
      notesPlaceholder="Detail who they will be sent to"
      i18n-notesPlaceholder="@@checklistMonitoring.earlyChannelSupply.notesPlaceholder"
      [disabled]="!isChecked('earlyChannelSupply.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item-single-choice
      label="Is early IT involvement required?"
      i18n-label="@@checklistMonitoring.earlyItInvolvementRequired.label"
      groupName="earlyItInvolvementRequired"
      [options]="this.checklistOptions['earlyItInvolvementRequired']"
      [disabled]="isControlDisabled('earlyItInvolvementRequired.choice')"
    >
    </app-checklist-item-single-choice>
    <hr />

    <app-checklist-item
      label="Has an IP address range been provided?"
      i18n-label="@@checklistMonitoring.ipAddressRangeProvided.label"
      groupName="ipAddressRangeProvided"
      notesPlaceholder="List range"
      i18n-notesPlaceholder="@@checklistMonitoring.ipAddressRangeProvided.notesPlaceholder"
      [disabled]="!isChecked('ipAddressRangeProvided.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Do we have department names?"
      i18n-label="@@checklistMonitoring.departmentNamesProvided.label"
      groupName="departmentNamesProvided"
      notesPlaceholder="List departments"
      i18n-notesPlaceholder="@@checklistMonitoring.departmentNamesProvided.notesPlaceholder"
      [disabled]="!isChecked('departmentNamesProvided.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Do we have bed names?"
      i18n-label="@@checklistMonitoring.bedNamesProvided.label"
      groupName="bedNamesProvided"
      notesPlaceholder="List bed names"
      i18n-notesPlaceholder="@@checklistMonitoring.bedNamesProvided.notesPlaceholder"
      [disabled]="!isChecked('bedNamesProvided.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Do we have a hospital short name?"
      i18n-label="@@checklistMonitoring.hospitalShortNameProvided.label"
      groupName="hospitalShortNameProvided"
      notesPlaceholder="List hospital name"
      i18n-notesPlaceholder="@@checklistMonitoring.hospitalShortNameProvided.notesPlaceholder"
      [disabled]="!isChecked('hospitalShortNameProvided.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Do we have hospital printer IP's?"
      i18n-label="@@checklistMonitoring.hospitalPrinterIpsProvided.label"
      groupName="hospitalPrinterIpsProvided"
      notesPlaceholder="List IP's"
      i18n-notesPlaceholder="@@checklistMonitoring.hospitalPrinterIpsProvided.notesPlaceholder"
      [disabled]="!isChecked('hospitalPrinterIpsProvided.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item-single-choice
      label="What commissioning is required?"
      i18n-label="@@checklistMonitoring.commissioningRequirementsProvided.label"
      subLabel="List what testing is required"
      i18n-subLabel="@@checklistMonitoring.commissioningRequirementsProvided.subLabel"
      groupName="commissioningRequirementsProvided"
      [options]="this.checklistOptions['commissioningRequirementsProvided']"
      [disabled]="isControlDisabled('commissioningRequirementsProvided.choice')"
    >
    </app-checklist-item-single-choice>
    <hr />

    <app-checklist-item
      label="Delivery details"
      i18n-label="@@checklistMonitoring.deliveryDetails.label"
      groupName="deliveryDetails"
      notesPlaceholder="Contact for delivery and dock description"
      i18n-notesPlaceholder="@@checklistMonitoring.deliveryDetails.notesPlaceholder"
      [disabled]="!isChecked('deliveryDetails.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Estimated Go-Live date"
      i18n-label="@@checklistMonitoring.estimatedGoLiveDate.label"
      groupName="estimatedGoLiveDate"
      notesPlaceholder="Enter Date"
      i18n-notesPlaceholder="@@checklistMonitoring.estimatedGoLiveDate.notesPlaceholder"
      [disabled]="!isChecked('estimatedGoLiveDate.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Additional information"
      i18n-label="@@checklistMonitoring.additionalInstallationInformation.label"
      groupName="additionalInstallationInformation"
      [disabled]="!isChecked('additionalInstallationInformation.checked')"
    >
    </app-checklist-item>

    <hr />
    <h6 class="odx-title-6 headline-padding" i18n="@@checklist.header.riskAssessment">Risikobewertung</h6>

    <app-checklist-item
      label="Deadline Risks?"
      i18n-label="@@checklistMonitoring.deadlineRisks.label"
      groupName="deadlineRisks"
      [disabled]="!isChecked('deadlineRisks.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Technical Risks?"
      i18n-label="@@checklistMonitoring.technicalRisks.label"
      groupName="technicalRisks"
      [disabled]="!isChecked('technicalRisks.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Other Risks?"
      i18n-label="@@checklistMonitoring.otherRisks.label"
      groupName="otherRisks"
      [disabled]="!isChecked('otherRisks.checked')"
    >
    </app-checklist-item>
    <hr />

    <app-checklist-item
      label="Discussion Notes"
      i18n-label="@@checklistMonitoring.discussionNotes.label"
      groupName="discussionNotes"
      [disabled]="!isChecked('discussionNotes.checked')"
    >
    </app-checklist-item>
  </form>
</div>
